import React from "react";
import classNames from "classnames";
import DismissX from "../../../icons/DismissX";

import classes from "./MessageTile.module.scss";

interface MessageTileProps {
  // style will be applied to the topmost element
  style?: any;
  // className will be applied to the topmost element
  className?: string;
  state: string;
  message: string;
  subtext?: string;
  subsubtext?: string;
  icon?: any;
  dismissAlertCb: () => any;
  // optionaly show the dismiss "x" in the right corner
  showDismiss?: boolean;
  messageTextStyles?: object;
}

const MessageTile: React.FC<MessageTileProps> = ({
  style,
  className,
  state,
  message,
  subtext,
  subsubtext,
  icon,
  dismissAlertCb,
  showDismiss = true,
  messageTextStyles,
}) => {
  return (
    <div
      className={classNames(
        classes.messageTileMain,
        {
          [classes.alert]: state === "alert",
          [classes.warning]: state === "warning",
          [classes.error]: state === "error",
          [classes.hasSubtext]: subtext,
          [classes.hasDismissX]: showDismiss,
        },
        className
      )}
      style={{
        ...style,
      }}
    >
      <div className={classes.top}>
        <span
          className={classes.icon}
          style={{ alignItems: `${subtext ? "flex-start" : "center"}` }}
        >
          {icon}
        </span>
        <p
          className={classes.mainMessage}
          style={{
            ...messageTextStyles,
            alignItems: `${subtext ? "flex-start" : "center"}`,
          }}
        >
          {message}
        </p>
      </div>
      <div className={classes.bottom}>
        {subtext ? <div className={classes.sub}>{subtext}</div> : null}
        {subsubtext ? (
          <div className={classes.sub} style={{ marginTop: "8px" }}>
            {subsubtext}
          </div>
        ) : null}
      </div>

      {showDismiss ? (
        <span
          style={{
            position: "absolute",
            right: "10px",
            top: "10px",
            cursor: "pointer",
          }}
          onClick={() => {
            dismissAlertCb();
          }}
        >
          <DismissX />
        </span>
      ) : null}
    </div>
  );
};

export default MessageTile;
